import { useGetDriversQuery } from "./useGetDriversQuery";

export const useGetDriverById = (id: number) => {
  const { data } = useGetDriversQuery();

  return data?.resources.find(driver => driver.id === id);
};
